<template>
  <div>    
    <vuex-table 
      :fields="fields" 
      table_store="stats/table"
      :foot_clone="true"
      :no_footer_sorting="true"
      total_caption=" "
      :show_per_page="false"
      :show_header="false"
    >
      <template #actions="{ item }">        
        <tooltip 
          :content="$t('projects.imports.field.title')"
          theme="light"
          placement="top-end"
          max-width="350px"
          class="text-left"
        >
          <table-control
            v-if="user.role != 'user'"
            type="import"
            :title="$t('projects.table.btn_type.import')"
            @click="goImport(item)"
          />
        </tooltip>
        <tooltip
          :content="$t('projects.table.btn_type.list')"
          theme="light"
          placement="top-end"
          max-width="350px"
          class="text-left"
        >
          <table-control
            type="list"
            :title="$t('projects.table.btn_type.list')"
            @click="taskList(item)"
          />
        </tooltip>
        <tooltip
          v-if="user.role != 'user'"
          :content="$t('projects.table.btn_type.edit')"
          theme="light"
          placement="top-end"
          max-width="350px"
          class="text-left"
        >
          <table-control
            type="edit"
            :title="$t('projects.table.btn_type.edit')"
            @click="edit(item)" />
        </tooltip>
        <!-- <table-control type="stats" :title="$t('projects.table.btn_type.stats')" @click="stats(item)" />-->
      </template>
    </vuex-table>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  // import { ProjectsService } from '@projects/services/ProjectsService';

  export default {
    computed: {
      ...mapGetters('core/auth', ['user']),
      fields() {
        return [
          
        ];
      }
    },
    created() {
      this.getAsyncData();
    },
    methods: {
      ...mapActions('stats/table', ['getAsyncData']),

      goImport(item) {
        this.$router.push({
          name: 'projects.import.create',
          params: {
            id: item.id,
            edit: true
          }
        });
      },
      taskList(item) {
        this.$router.push({ name: 'tasks.list', params: { project_id: item.id } });
      },
      edit(item) {
        this.$router.push({ name: 'projects.edit', params: { id: item.id } });
      }
    }
  };
</script>
